import { User, Workspace, Team } from 'src/components/types';

export type ProfileSectionState = {
  currentUser: User | Team | undefined;
  currentWorkspace: Workspace | undefined;
};

export function isTeam(
  currentUser: User | Team | undefined
): currentUser is Team {
  return (currentUser as Team).type === 'team';
}
